import { ENTRYPOINT } from "../config/api";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "./i18n/en";
import frenchMessages from "./i18n/fr";

const detectBrowserLanguage = () => {
  const browserLanguage = navigator.language.split("-")[0];
  return ["en", "fr"].includes(browserLanguage) ? browserLanguage : "en";
};

// Fetch ontology data
const fetchOntology = async (locale) => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 10000);
  try {
    const response = await fetch(`${ENTRYPOINT}/ontology/${locale}`, {
      signal: controller.signal,
      headers: {
        "Cache-Control": "max-age=604800", // refresh browser cache every week
      },
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch ontology for locale ${locale}`);
    }
    return await response.json();
  } catch (error) {
    console.error(error);
    return {};
  } finally {
    clearTimeout(timeout);
  }
};

// Initial language detection
const defaultLanguage =
  localStorage.getItem("selectedLanguage") || detectBrowserLanguage();
let initializing = true;

const i18nProvider = polyglotI18nProvider(
  (locale) => {
    localStorage.setItem("selectedLanguage", locale);
    if (initializing) {
      initializing = false;
      return locale === "fr" ? frenchMessages : englishMessages;
    }
    return fetchOntology(locale).then((ontology) => {
      if (locale === "fr") {
        return {
          ...frenchMessages,
          ...ontology,
        };
      }
      // Always fallback on english
      return {
        ...englishMessages,
        ...ontology,
      };
    });
  },
  defaultLanguage,
  [
    { locale: "en-GB", name: "English (United Kingdom)" },
    { locale: "en", name: "English (United States)" },
    { locale: "fr", name: "Français" },
  ]
);
export const initializeTranslations = () =>
  i18nProvider.changeLocale(defaultLanguage);

export default i18nProvider;
